import { z } from 'zod'

// Mirrors CreatePublicCaseDto: mobile tightens to the real backend regex (was a looser /^\d{10}$/),
// and the slot field maps straight to `consultationSlotAt` — a real ISO 8601 datetime string
// produced by the picker in submission-successful-view.tsx, not free text.
export const submissionSuccessfulSchema = z.object({
  mobile: z.string().regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit mobile number.'),
  consultationSlotAt: z.string().min(1, 'Pick a callback time.'),
})

export type SubmissionSuccessfulFormValues = z.infer<typeof submissionSuccessfulSchema>
